(ns app.front.view.group.admin.form-schemas.form
  (:require [app.domain.group.model :as group-model]
            [app.front.entities :as entities]
            [app.front.file.upload :as upload]
            [app.front.form.render :as fr]
            [app.front.form.render-edit :as fre]
            [app.front.form.subs :as form-subs]
            [app.front.ui :as ui]
            [app.front.ui.floating-action-bar :as ui-fab]
            [app.front.util :as futil]
            [app.front.view.group.admin.form-schemas.form-mock-data :as mock-data]
            [app.front.view.group.admin.form-schemas.subs :as form-schemas-subs]
            [app.front.view.group.admin.subs :as gas]
            [app.front.view.not-found :as not-found]
            [clojure.string :as str]
            [core.front.carbon :as cc]
            [core.front.date-util :as date-util]
            [core.front.event :refer [<sub >evt]]
            [core.front.feature-flags :as ff]
            [core.front.href :as href]
            [core.front.icons :as i]
            [core.permission.resolver :as permission-resolver]
            [core.util.util :as util]
            [re-frame.core-instrumented :as rf]
            [schema.core :as s]))


(defn title-field [edit?]
  (let [schema-name (<sub [::form-schemas-subs/schema-name])]
    (if edit?
      [ui/text-input
       {:id            "schema-name"
        :input-class   "text-lg font-bold"
        :label-text    ""
        :light         true
        :default-value schema-name
        :on-blur       #(let [value (str/trim (futil/tval %))]
                          (>evt [::form-schemas-subs/rename value]))}]
      [:h2 schema-name])))


(defn- export-schema-button
  []
  (let [export-url (<sub [::form-schemas-subs/schema-export-url])
        tr         (<sub [:tr])]
    (cc/button
      {:id         "export-schema-data"
       :size       :small
       :kind       :tertiary
       :class-name "mt-1"
       :icon       i/download
       :href       export-url}
      (tr [:form.schema/export-schema]))))


(defn- import-schema-button
  []
  (let [schema-id (<sub [::form-schemas-subs/schema-id-from-route])
        tr        (<sub [:tr])]
    [upload/file-picker-button
     {:id           (str "import-form-data-schema" schema-id)
      :tr           tr
      :accept-types [".edn"]
      :class        "ml-2 mt-1"
      :button-opts  {:kind             :tertiary
                     :size             :small
                     :icon             i/upload
                     :icon-description (tr [:form.schema/import-schema])}
      :on-select-fn (partial form-schemas-subs/import-form-data-schema-file
                             schema-id)}
     (tr [:form.schema/import-schema])]))


(defn- edit-button
  []
  (let [tr (<sub [:tr])]
    (cc/button
      {:id               "edit-btn"
       :size             :small
       :kind             :primary
       :class-name       "ml-2 mt-2"
       :icon-description ""
       :on-click         #(>evt [::form-schemas-subs/form-edit-toggle true])
       :icon             i/pen}
      (tr [:form.schema/edit]))))


(defn- view-shared-form-button
  []
  (let [schema-id         (<sub [::form-schemas-subs/schema-id-from-route])
        group-id          (<sub [::form-schemas-subs/group-id-from-route])
        form-schema       (<sub [::entities/entity schema-id])
        shared-form-group (:domain/authority-group form-schema)
        user              (<sub [:session/user])
        tr                (<sub [:tr])]
    (when (and (ff/enabled? :feature-flag.id/shared-form-editor-link)
               (group-model/superdomain? shared-form-group)
               (permission-resolver/permitted? shared-form-group user :permission.group/admin))
      (cc/button
        {:id               "view-shared-form-btn"
         :size             :small
         :kind             :primary
         :class-name       "ml-2 mt-2"
         :icon-description ""
         :href             (href/href :view/group.admin.form
                                      {:group-id  (:db/id shared-form-group)
                                       :schema-id schema-id}
                                      {:origin-group-id group-id})
         :icon             i/arrow-right}
        (tr [:form.schema/view-shared-form])))))


(defn remove-button
  []
  (let [tr           (<sub [:tr])
        schema-db-id (<sub [::form-schemas-subs/schema-id-from-route])
        group-id     (<sub [::form-schemas-subs/group-id-from-route])]
    [ui/modal-confirmation-button {:tr                  tr
                                   :id                  "remove-btn"
                                   :modal-title         (tr [:form.schema/remove-form-schema])
                                   :trigger-button-opts {:icon       i/trash
                                                         :kind       :tertiary
                                                         :class-name "mt-2"
                                                         :size       :small}
                                   :trigger-button-text (tr [:remove])
                                   :on-yes-click        #(>evt [::form-schemas-subs/delete-form-schema group-id schema-db-id])}
     (tr [:are-you-sure])]))


(defn- cancel-button
  []
  (let [tr (<sub [:tr])]
    (cc/button
      {:id               "cancel-btn"
       :size             :small
       :kind             :tertiary
       :class-name       "ml-2 mt-1"
       :icon-description ""
       :on-click         #(>evt [::form-schemas-subs/cancel-form-edit])
       :icon             i/remove}
      (tr [:form.schema/cancel]))))


(defn- save-button
  []
  (let [tr        (<sub [:tr])
        group-id  (<sub [::form-schemas-subs/group-id-from-route])
        schema-id (<sub [::form-schemas-subs/schema-id-from-route])
        disabled? (<sub [::form-schemas-subs/save-disabled?])]
    (cc/button
      {:id               "save-btn"
       :size             :small
       :kind             :primary
       :class-name       "ml-2 mt-1"
       :disabled         disabled?
       :icon-description ""
       :on-click         #(>evt [::form-schemas-subs/save-form-schema group-id schema-id])
       :icon             i/save}
      (tr [:form.schema/save]))))


(def error-help :span.text-ui-red.mt-1)


(defn- last-modified-label
  []
  (let [latest-change    (<sub [::form-schemas-subs/schema-latest-change-ts])
        version          (<sub [::form-schemas-subs/schema-version])
        tr               (<sub [:tr])
        format-date-time (<sub [::date-util/date-time-fn])]
    [:div.mt-2.mr-2.flex.flex-col.items-end
     [:span.text-gray-800
      (str (tr [:form.schema/form-type])
           ": "
           (tr [(<sub [::form-schemas-subs/schema-type])])
           " / "
           (when (<sub [::form-schemas-subs/schema-is-authority-form?])
             (str (tr [:form.schema/authority-form]) " / "))
           (tr [:form.schema/version-saved-on]
               [version
                (or (some-> latest-change format-date-time)
                    "-")]))]
     (when-not (<sub [::form-schemas-subs/required-fields-filled?])
       [error-help (tr [:form-editor/missing-data])])
     (when-let [conflicts (seq (<sub [::form-schemas-subs/conflicting-fields]))]
       [error-help (tr [:form-editor/conflicting-fields]
                       (->> conflicts
                            (map (comp name :field))
                            (str/join ", ")
                            vector))])
     (when-some [invalid-fields (<sub [::form-schemas-subs/invalid-fields])]
       [error-help {:title (str/join "\n\n" (map #(str (second %) "\n" (first %)) invalid-fields))}
        (tr [:form-editor/invalid-data])])
     (cond (not (<sub [::form-schemas-subs/no-locally-conflicting-fields?]))
           [error-help (tr [:form-editor/locally-conflicting-fields-err])]
           (not (<sub [::form-schemas-subs/no-locally-duplicate-fields?]))
           [:span (tr [:form-editor/locally-conflicting-fields])])]))


(defn action-bar [editing?]
  (let [inherited? (<sub [::form-schemas-subs/inherited?])]
    [ui-fab/floating-action-bar {:class "[&>*]:!m-0 [&_button]:!h-12 [&_a]:!h-12"}
     [:<>
      (when-not editing?
        [:<>
         [export-schema-button]
         [import-schema-button]])
      [:div.flex-1]
      [:div.px-2
       {:class "[&>*]:!m-0"}
       [last-modified-label]]
      (if editing?
        [:<>
         [cancel-button]
         [save-button]]
        (if inherited?
          [view-shared-form-button]
          [:<>
           [remove-button]
           [edit-button]]))]]))


(defn schema-content [{:keys [edit? json-schema-data hiccup-schema-data ctx tr]}]
  (let [editing? (and edit? json-schema-data)]
    [:div.flex.flex-wrap.w-full
     [:div.p-2 {:class (if editing? "w-full lg:w-1-2" "w-full")}
      [:div.px-4.mb-8
       [title-field edit?]]
      (if editing?
        [fre/render ctx nil nil json-schema-data]
        [fr/render ctx 0 nil hiccup-schema-data])]
     (when editing?
       [fre/configuration-box {:tr                 tr
                               :authority-group-id (-> ctx :form-schema :domain/authority-group :db/id)}])
     [action-bar editing?]]))


(defn view [{{{:keys [schema-id group-id]} :path} :parameters}]
  (let [form-schema      (<sub [::entities/entity schema-id])
        form-schema-data (:form.schema/data-schema form-schema)
        edit?            (<sub [::form-schemas-subs/form-edit?])
        tr               (<sub [:tr])
        tr-schema        (<sub [::form-subs/tr-schema tr])
        ctx              (-> (merge (util/mmap {:preview? true} tr tr-schema form-schema group-id)
                                    mock-data/mock-data-ctx)
                             (assoc-in [:form :form/schema] form-schema))
        loading?         (<sub [::form-schemas-subs/fetching-schema?])]
    [:div.cloudpermit-page
     (cond
       loading?
       (cc/loading-spinner)

       form-schema-data
       [schema-content (util/mmap {:json-schema-data   (<sub [::form-schemas-subs/form-element-by-path [0]])
                                   :hiccup-schema-data (:form.schema/data-schema form-schema)}
                                  edit? ctx tr)]

       :else
       [not-found/not-found-view])]))


(defn form-back-target [{{:keys [group-id schema-id]} :path
                         {:keys [origin-group-id]}    :query}]
  (if origin-group-id
    {:route  :view/group.admin.form
     :params {:group-id  origin-group-id
              :schema-id schema-id}}
    {:route  :view/group.admin.forms
     :params {:group-id group-id}}))


(rf/reg-sub ::view-data
  :<- [:route/match]
  :<- [:branding/as-string]
  (fn [[{:keys [parameters]} branding] _]
    (let [{:keys [route params]} (form-back-target parameters)]
      {:back-href (href/branded-href branding route params)})))




(def route
  {:name        :view/group.admin.form
   :view        view
   :view-sub    [::view-data]
   :parameters  {:path  {:group-id  s/Int
                         :schema-id s/Int}
                 :query {(s/optional-key :origin-group-id) s/Int}}
   :controllers [{:parameters {:path [:group-id :schema-id]}
                  :start      (fn [{{:keys [group-id schema-id]} :path}]
                                (>evt [::form-schemas-subs/fetch-form-schema group-id schema-id])
                                (>evt [::form-schemas-subs/fetch-translation-entries group-id])
                                (>evt [::form-schemas-subs/scroll-to-top])
                                (>evt [::gas/fetch-party-roles group-id]))
                  :stop       (fn []
                                (>evt [::form-schemas-subs/quit-form-edit]))}]})
